import "./Project1Layout.scss";
import ProjectImage from "../../projectimage/ProjectImage";

export default function Project1Layout({ projectData = {} }) {
  return (
    <>
      <div
        className={`project-page project-layout1 ${projectData?.projectName}`}
      >
        <div
          id="section3"
          className="vertical-dotted-container fixed-vertical-dot"
        ></div>
        {projectData.projectTitle && (
          <div className="project-title d-flex justify-content-center">
            <div className="title">
              <div className="project-name">
                <h3>{projectData.projectTitle}</h3>
              </div>
            </div>
          </div>
        )}
        <div className="vertical-image-grid">
          {projectData?.projectDetails?.map((project, index) => (
            <div className="grid-container">
              <div>
                {project.description && (
                  <div className="project-description">
                    <div className="description">
                      <p className="text-3xl font-bold underline">
                        {project?.description}
                      </p>
                    </div>
                  </div>
                )}

                {project?.imageSrc && (
                  <div class="portrait-landscape-layout">
                    <div className="project-image-wrapper">
                      <div className="image-grid">
                        <div className="mobile-image-title d-md-none d-lg-none">
                          <div className="image-title">
                            {index + 1} / {projectData?.projectDetails?.length}
                          </div>
                          {/* <div className="copy-right d-md-none">
                            <span>
                              {index === 0 && projectData?.photoGrapherName
                                ? "photos//" +
                                  " " +
                                  projectData?.photoGrapherName
                                : null}
                            </span>
                          </div> */}
                        </div>
                        <div className="wrapv d-none d-md-block d-lg-block">
                          <div className="vertical">
                            {index + 1} / {projectData?.projectDetails?.length}
                          </div>
                        </div>
                        <ProjectImage
                          key={index}
                          project={project}
                          index={index}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
          <div className="project-title d-flex justify-content-center">
            <div className="title flex-column">
              {projectData.creditsFooter && (
                <div className="copy-right-footer d-md-flex mb-2">
                  <span>{projectData.creditsFooter}</span>
                </div>
              )}
              {projectData?.photoGrapherName && (
                <div className="copy-right-footer d-md-flex">
                  <span>photos // {projectData?.photoGrapherName}</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="blank-space container"></div>
      </div>
    </>
  );
}
